import { render, staticRenderFns } from "./sales-status.vue?vue&type=template&id=abbada36"
import script from "./sales-status.vue?vue&type=script&lang=js"
export * from "./sales-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports